import SponsorPaymentBank from ".././../../../../component/systemMaster/sponsorBank/sponsorBankPayment/sponsorPaymentBank/sponsorPaymentBank";
const SponsorPaymentBanks=()=>{
    return <SponsorPaymentBank/>
}
export default SponsorPaymentBanks;